module.exports = __webpack_public_path__ + "43293d521b42c03e4ef8569e722f07f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-main-768.jpg
// module id = 460
// module chunks = 0